import { Component, Input } from '@angular/core';
import { ContainerComponent } from '../container/container.component';
import { CommonModule } from '@angular/common';

export interface Callout {
  icon: string;
  alt?: string;
  title: string;
  text: string;
}

@Component({
  selector: '[callout]',
  imports: [ContainerComponent, CommonModule],
  templateUrl: './callout.component.html',
  styleUrl: './callout.component.scss',
})
export class CalloutComponent {
  @Input() data: Callout = {
    icon: '',
    alt: '',
    title: '',
    text: '',
  };
}
